import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PlanList from "../../Components/PlanList";
import MinPlanPrice from "../../Components/MinPlanPrice";
import OperatingSystem from "../../Components/OperatingSystem";
import sal from "sal.js";
import { Helmet } from "@dr.pogodin/react-helmet";
import { ScrollToPlans } from "../../utils/ScrollToPlan";
import CouponScrollBar from "../../Components/CouponScrollBar";

export default function DedicatedServerGermany() {
  const [applyPaddingClass, setApplyPaddingClass] = useState(false);
  useEffect(() => {
    document.title = "Reliable Dedicated Servers Germany for High-Speed Hosting";
      sal();
  }, []);
  const handlePlanClick = () => {
    ScrollToPlans(".price-plan-section");
    };
  return (
    <>
        <Helmet>
            <title>Reliable Dedicated Servers Germany for High-Speed Hosting</title>
            <meta name="description" content="Boost your business with Dedicated Servers Germany, offering powerful hardware, fast connectivity, full control, 24/7 expert support, and unmatched reliability." />
            <meta name="keywords" content="German Dedicated Server, Dedicated Servers Germany" />
            <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/dedicated-server-germany`} />
            <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/dedicated-server-germany`} />
            <meta property="og:title" content="Dedicated Server in Germany: Reliable Hosting in Europe" />
            <meta property="og:description" content="Enhance your digital presence with a dedicated server in Germany. Get high speed, security & smooth access across Europe, ideal for high-demand business needs." />
        </Helmet>
        <section className="banner-bg bg-dark ssl-banner">
            <div className="container">
                <div className="row align-items-center g-4">
                    <div className="col-lg-6">
                        <div className="pb-40">
                            <span className="fs-18 fw-bold text-primary mb-2 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Servers That Work Just For You</span>
                            <h1 className="text-white mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            Dedicated Server Germany: Never Ghosts You</h1>
                            <p className="text-white mb-8 max-text-60 text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Missing high traffic? Issues in loading? Feels like your server is always holding you back? Let a dedicated server Germany change the whole game high speeds, stable uptime, and no more panic at the time of peak hours.
                            </p>
                            <div className="d-flex align-items-center gap-5 flex-wrap sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                <button onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded sal-animate btn-height" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                    <span className="btn-arrow__text">
                                        View All Plans
                                        <span className="btn-arrow__icon">
                                            <i className="fa-solid fa-arrow-right"></i>
                                        </span>
                                    </span>
                                </button>
                                <MinPlanPrice category="customizeddger" />
                            </div>
                            <span className="d-block fs-14 text-white text-opacity-75 mt-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Get 100% Refund Within 30 Days* <sup><small className="text-opacity-50 tnc-text">T&Cs</small></sup></span>
                        </div>
                    </div>
                    <div className="col-lg-6 col-xxl-6"><div className="sal-animate" data-sal="fade" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine"><img alt="image" className="img-fluid" src="/images/dedicated-server-germany.webp"/></div></div>
                </div>
            </div>
        </section>

        <section className="responsive-pt-100 pb-100">
        <div className="container">
            <div className="row align-items-center justify-content-between g-4">
                <div className="col-xl-6 col-lg-10">
                  <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded"><span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>With Us You Don't Cry Anymore</small>
                    <h2 className="mb-0 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Tired Servers Cry Here: Germany Server Doesn’t Miss</h2>
                </div>
            </div>
            <div className="mt-8">
                <div className="row g-4">
                    <div className="col-lg-4 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <div className="ssl-benefit-item px-5 py-7 little-dark-border hover-shadow transition rounded-3 bg-white h-100">
                            <img src="images/engineered-for-speed.webp" alt="icon" className="img-fluid mb-4" />
                            <h6 className="mb-2">Engineered for Speed, Tuned for You</h6>
                            <p className="mb-0">No more resource sharing, no slowing the server down, and no crashes. Just seamless performance with every click. Your users get the desired speed.</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                        <div className="ssl-benefit-item px-5 py-7 little-dark-border hover-shadow transition rounded-3 bg-white h-100">
                            <img src="images/from-setup-to.webp" alt="icon" className="img-fluid mb-4" />
                            <h6 className="mb-2">From Setup to Exceptional Power</h6>
                            <p className="mb-0">Take access to everything from the OS to the web server. With the help of our SSD-based dedicated server Germany, it’s all about your rules.</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                        <div className="ssl-benefit-item px-5 py-7 little-dark-border hover-shadow transition rounded-3 bg-white h-100">
                            <img src="images/10-gbps-hosting.webp" alt="icon" className="img-fluid mb-4" />
                            <h6 className="mb-2">10 Gbps Hosting, German Style</h6>
                            <p className="mb-0">Do you still sick of slow load times? Not with our dedicated server Germany. Your heavy sites and app fly on our 10 Gbps Germany dedicated server.</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="600" data-sal-easing="ease-in-out-sine">
                        <div className="ssl-benefit-item px-5 py-7 little-dark-border hover-shadow transition rounded-3 bg-white h-100">
                            <img src="images/you-re-the-real.webp" alt="icon" className="img-fluid mb-4" />
                            <h6 className="mb-2">You’re the Real Boss, All the Time</h6>
                            <p className="mb-0">You get all the keys to your dedicated server Germany-install what you wish for, delete what you don’t use, and run all the things your way.</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="700" data-sal-easing="ease-in-out-sine">
                        <div className="ssl-benefit-item px-5 py-7 little-dark-border hover-shadow transition rounded-3 bg-white h-100">
                            <img src="images/everything-you-wish-for.webp" alt="icon" className="img-fluid mb-4" />
                            <h6 className="mb-2">Everything You Wish For, All in One</h6>
                            <p className="mb-0">Ranging from SSH access and databases to file controls and support, our dedicated server Germany is made to vibe with all your demands.</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="800" data-sal-easing="ease-in-out-sine">
                        <div className="ssl-benefit-item px-5 py-7 little-dark-border hover-shadow transition rounded-3 bg-white h-100">
                            <img src="images/no-more-waiting.webp" alt="icon" className="img-fluid mb-4" />
                            <h6 className="mb-2">No More Waiting, Just Launching</h6>
                            <p className="mb-0">Do you also hate the wait? We don’t like making our clients wait either. Your server is set to deploy within hours, pre-loaded with your setup.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </section>

        <section className="price-plan-section pt-100 pb-100 position-relative">
          <CouponScrollBar setPaddingClass={setApplyPaddingClass} />
          <div className={`pb-40 ${applyPaddingClass ? "plan-extra-top-padding" : ""}`}>
              <div className="container">
                  <div className="row justify-content-center">
                      <div className="col-xl-8">
                          <div className="text-center">
                              <span className="section-title-dark style-bg fadeInUp">Our Plans</span>
                              <h2 className="theme-title-text-white" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine"> You dream about it. We host it.</h2>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        <PlanList category={'customizeddger'}/>
        </section>

        <div className="pb-100 pt-100">
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-lg-6">
                        <div className="ps-lg-8 pe-xxl-12">
                            <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                24/7 Support
                            </span>
                            <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Server Help? We’re Just a DM Away
                            </h3>
                            <p data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate">
                                Don’t worry you have us, 24/7. Our experts are always ready to jump in and help with any server headache, either big or small. Expect customized, hands-on support all the time.
                                Shhh… Don’t Tell Anyone About What You Get Here:
                            </p>
                                <ul>
                                    <li>Support Anytime You Need It</li>
                                    <li>Live Chat and Calls Quick Acces</li>
                                    <li>Instant Server Monitoring</li>
                                </ul>
                            <Link to="#" onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded btn-height">
                                <span className="btn-arrow__text">
                                    Get Started Now
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </Link>
                        </div>
                    </div>
                    <div className="col-lg-6 sal-animate ipad-mt" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <img src="images/aerver-help-we’re-just.webp" alt="image" className="img-fluid full-width-img" />
                    </div>
                </div>
            </div>
        </div>

        <section className="bg-dark pt-100 pb-100">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xxl-7 col-xl-8">
                        <div className="d-flex align-items-center justify-content-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <div className="w-2 h-2 rounded-circle bg-primary"></div>
                            <small className="text-primary fw-bold">Perks of Our Servers</small>
                        </div>
                        <div className="text-center mb-8">
                            <h2 className="text-white mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Not Getting What You Really Paid For?</h2>
                            <p className="text-white mb-0 max-text-56 mx-auto sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">It’s the best time to stop settling for the bare minimum and start succeeding. With our managed dedicated hosting, you get desired performance, privacy, and full room to scale, without the tech issues.</p>
                        </div>
                    </div>
                </div>
                <div className="row g-4">
                    <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <div className="bg-white bg-opacity-5 p-6 p-xl-10 rounded-3 h-100">
                            <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                                <h5 className="text-white mb-0">Smarter Configs, Zero Hassle</h5>
                                <p className="h5 mb-0 text-white text-opacity-25">01</p>
                            </div>
                            <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                                <div className="flex-shrink-0">
                                    <img src="images/smarter-configs.webp" alt="icon" className="img-fluid" />
                                </div>
                                <div>
                                    <p className="text-white mb-4">Fed up with juggling server loads? With our dedicated server Germany, performance issues fade. Everything’s improved-so your website runs smoothly, even at the time of high traffic.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                        <div className="bg-white bg-opacity-5 p-6 rounded-3 p-xl-10 h-100">
                            <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                                <h5 className="text-white mb-0">1-Click & Boom, You’re Online</h5>
                                <p className="h5 mb-0 text-white text-opacity-25">02</p>
                            </div>
                            <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                                <div className="flex-shrink-0">
                                    <img src="images/1-click-&-boom.webp" alt="icon" className="img-fluid" />
                                </div>
                                <div>
                                    <p className="text-white mb-4">Why wait too long? Launch your website in seconds with our dedicated server hosting Germany. Ranging from WordPress to Magento-simply click, install, and you’re all set to roll.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <div className="bg-white bg-opacity-5 p-6 p-xl-10 rounded-3 h-100">
                            <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                                <h5 className="text-white mb-0">Fast Just Got Faster</h5>
                                <p className="h5 mb-0 text-white text-opacity-25">03</p>
                            </div>
                            <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                                <div className="flex-shrink-0">
                                    <img src="images/fast-just-got-faster.webp" alt="icon" className="img-fluid" />
                                </div>
                                <div>
                                    <p className="text-white mb-4">Lag? Who is this? Our dedicated server Germany gives your business the amazing speed that it craves, powered by modern tech and quick upgrade options.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                        <div className="bg-white bg-opacity-5 p-6 rounded-3 p-xl-10 h-100">
                            <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                                <h5 className="text-white mb-0">Built Different</h5>
                                <p className="h5 mb-0 text-white text-opacity-25">04</p>
                            </div>
                            <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                                <div className="flex-shrink-0">
                                    <img src="images/built-different.webp" alt="icon" className="img-fluid" />
                                </div>
                                <div>
                                    <p className="text-white mb-4">Your business deserves more power, not just average. With our dedicated server hosting Germany, you get enterprise-level hardware engineered for heavy lifting-no more slow load times.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <div className="bg-white bg-opacity-5 p-6 p-xl-10 rounded-3 h-100">
                            <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                                <h5 className="text-white mb-0">Ping Us Anytime</h5>
                                <p className="h5 mb-0 text-white text-opacity-25">05</p>
                            </div>
                            <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                                <div className="flex-shrink-0">
                                    <img src="images/ping-us-anytime.webp" alt="icon" className="img-fluid" />
                                </div>
                                <div>
                                    <p className="text-white mb-4">Midnight crash? Business Edge, we are up just for you. Our 24/7 support means your dedicated server Germany is always running powerfully-day or night, rain or shine.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                        <div className="bg-white bg-opacity-5 p-6 rounded-3 p-xl-10 h-100">
                            <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                                <h5 className="text-white mb-0">You’re in Charge Now</h5>
                                <p className="h5 mb-0 text-white text-opacity-25">06</p>
                            </div>
                            <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                                <div className="flex-shrink-0">
                                    <img src="images/you-re-in-charge-now.webp" alt="icon" className="img-fluid" />
                                </div>
                                <div>
                                    <p className="text-white mb-4">Want full freedom when you pay? Obviously, who wouldn’t? With our Dedicated Server Hosting Germany, you get access to personalize, tweak, and rule your server like a legend.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <div className="bg-white bg-opacity-5 p-6 p-xl-10 rounded-3 h-100">
                            <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                                <h5 className="text-white mb-0">You Run the Show</h5>
                                <p className="h5 mb-0 text-white text-opacity-25">07</p>
                            </div>
                            <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                                <div className="flex-shrink-0">
                                    <img src="images/you-run-the.webp" alt="icon" className="img-fluid" />
                                </div>
                                <div>
                                    <p className="text-white mb-4">Make it fully yours. With the help of our Dedicated Server Germany, you select what actually runs, how it runs, and at what time. Prefer we manage it? Just say the word.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                        <div className="bg-white bg-opacity-5 p-6 rounded-3 p-xl-10 h-100">
                            <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                                <h5 className="text-white mb-0">Bye Spam, Hello Clean Inbox</h5>
                                <p className="h5 mb-0 text-white text-opacity-25">08</p>
                            </div>
                            <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                                <div className="flex-shrink-0">
                                    <img src="images/bye-spam-hello.webp" alt="icon" className="img-fluid" />
                                </div>
                                <div>
                                    <p className="text-white mb-4">Fed up with junk mail? Our dedicated server hosting Germany always comes with robust spam filters and virus blockers-so your inbox usually stays clean and secure.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                        <div className="bg-white bg-opacity-5 p-6 rounded-3 p-xl-10 h-100">
                            <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                                <h5 className="text-white mb-0">Choose: Intel or AMD</h5>
                                <p className="h5 mb-0 text-white text-opacity-25">09</p>
                            </div>
                            <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                                <div className="flex-shrink-0">
                                    <img src="images/choose-intel.webp" alt="icon" className="img-fluid" />
                                </div>
                                <div>
                                    <p className="text-white mb-4">Need performance that doesn’t flinch? Our Dedicated Server Germany provides the modern Intel & AMD processors-customized according to your needs, not the other way around.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                        <div className="bg-white bg-opacity-5 p-6 rounded-3 p-xl-10 h-100">
                            <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                                <h5 className="text-white mb-0">FREE SSL, Full Trust</h5>
                                <p className="h5 mb-0 text-white text-opacity-25">10</p>
                            </div>
                            <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                                <div className="flex-shrink-0">
                                    <img src="images/free-ssl-full-trust.webp" alt="icon" className="img-fluid" />
                                </div>
                                <div>
                                    <p className="text-white mb-4">Security is not a choice. Every single dedicated server Germany plan consists of a free SSL certificate-safeguarding all your essential data and gaining site visitor trust instantly.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <OperatingSystem/>
        
        <section className="pt-60 pb-100">
            <div className="container">
                <div className="cta-wrapper-one pt-60 pb-60 px-6 rounded-3">
                    <div className="row justify-content-center">
                        <div className="col-xxl-7 col-xl-9">
                            <div className="d-flex justify-content-center sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                                <div className="px-3 py-1 border border-primary rounded d-inline-flex align-items-center gap-2">
                                    <div className="w-2 h-2 rounded-circle bg-primary"></div>
                                    <small className="text-primary fw-bold">No More Unexpected Crashes</small>
                                </div>
                            </div>
                            <div className="text-center mt-5">
                                <h2 className="mb-5 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Don’t Lie... Website Crashes at the Wrong Time?</h2>
                                <p className="mb-8 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Get the control, speed, performance, and uptime you’ve been missing. Your ideal dedicated server in Germany is just a click away. </p>
                            </div>
                            <div className="d-flex align-items-center justify-content-center gap-4 flex-wrap flex-md-nowrap sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                                <Link to="#" onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-arrow-md btn-lg fs-14 fw-medium rounded btn-height">
                                    <span className="btn-arrow__text">
                                        Start Now
                                        <span className="btn-arrow__icon">
                                            <i className="fa-solid fa-arrow-right"></i>
                                        </span>
                                    </span>
                                </Link>
                                <Link to="/frequently-asked-questions" className="btn btn-dark btn-arrow btn-arrow-md btn-lg fs-14 fw-medium rounded btn-height">
                                    <span className="btn-arrow__text">
                                        Learn More
                                        <span className="btn-arrow__icon">
                                            <i className="fa-solid fa-arrow-right"></i>
                                        </span>
                                    </span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  );
}
